import * as Yup from 'yup'

export const getLoginValidationSchema = translations =>
  Yup.object().shape({
    userName: Yup.string()
      .email(translations('agreements.login-validation.username-pattern'))
      .required(translations('agreements.login-validation.username-empty')),
    password: Yup.string().required(translations('agreements.login-validation.password-empty'))
  })
